module.exports = __webpack_public_path__ + "img/product4.9c91e878.png";